import { useCallback, useMemo, useState, Dispatch, SetStateAction } from 'react'
import { UnitsList } from '../redux/slices/userSlice'
import { hasSettingsChanged } from '../utils/SettingsUtils'

const selectedUnitsById = (units: UnitsList[]) =>
    Object.fromEntries((units ?? []).map((i) => [i.id, i.selected]))

export const useUnits = (
    initialUnits: UnitsList[],
): {
    units: UnitsList[]
    setUnits: Dispatch<SetStateAction<UnitsList[]>>
    onChangeUnits: (id: string, selected: string) => void
    isUnitsUpdated: boolean
} => {
    const [units, setUnits] = useState<UnitsList[]>(initialUnits)
    const [savedUnits] = useState<UnitsList[]>(initialUnits)

    /* Compared against the units the form opened with, so changing a unit
       and changing it back is no longer an update. */
    const isUnitsUpdated = useMemo(
        () =>
            hasSettingsChanged(
                selectedUnitsById(units),
                selectedUnitsById(savedUnits),
            ),
        [units, savedUnits],
    )

    const onChangeUnits = useCallback((id: string, selected: string) => {
        setUnits((prev) => {
            return (
                prev?.map((i) => {
                    if (i.id === id) {
                        return { ...i, selected }
                    } else {
                        return i
                    }
                }) || []
            )
        })
    }, [])

    return { units, setUnits, onChangeUnits, isUnitsUpdated }
}
